import { nextTick } from 'vue'

type ScrollIntoView = {
  scrollIntoView: (target: string | HTMLElement) => Promise<void>
}

export const useScrollIntoView = (): ScrollIntoView => {
  /**
   * @param target - CSS selector, element ID (.selector or #selector) or an HTMLElement
   */
  const scrollIntoView = async (target: string | HTMLElement): Promise<void> => {
    await nextTick()

    const element =
      typeof target === 'string'
        ? target.startsWith('#')
          ? document.getElementById(target.slice(1))
          : (document.querySelector(target) as HTMLElement | null)
        : target

    if (!element) {
      return
    }

    try {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    } catch {
      // Fallback for older browsers
      element.scrollIntoView()
    }
  }

  return {
    scrollIntoView,
  }
}
